import { Component, OnInit, Input } from '@angular/core';

/**
 * A component for show a range of date and avoid logic in parents.
 *
 * @export
 * @class DateEventComponent
 * @implements {OnInit}
 */
@Component({
  selector: 'app-date-event',
  templateUrl: './date-event.component.html',
  styleUrls: ['./date-event.component.scss']
})
export class DateEventComponent implements OnInit {

  /**
   * Date from input.
   *
   * @type {(Date | string)}
   * @memberof DateEventComponent
   */
  @Input() dateFrom: string;

  /**
   * Date to input.
   *
   * @type {(Date | string)}
   * @memberof DateEventComponent
   */
  @Input() dateTo: string;

  /**
   * Date result for internal use of component.
   *
   * @type {{
   *     isSameDay: boolean,
   *     isSameYear: boolean,
   *     isSameMonth: boolean,
   *     first: Date,
   *     last: Date
   *   }}
   * @memberof DateEventComponent
   */
  dateResult: {
    isSameDay: boolean,
    isSameYear: boolean,
    isSameMonth: boolean,
    first: Date,
    last: Date|string
  };
  constructor() { }

  ngOnInit() {
    this.dateResult = this.calculateDateRange();
  }

  /**
 * A method for calculate the ranged date and check if is the same day
 *
 * @param {string} date_from date from parameter
 * @param {string} date_to date to parameter
 * @returns
 * @memberof BootstraAthleteMatchesComponent
 */
  calculateDateRange() {
    const dateFrom = new Date(this.dateFrom);
    const dateTo = this.dateTo != undefined ?  new Date(this.dateTo) : 'Not DateTo';
    return {
      isSameDay: dateFrom.toString() === dateTo.toString(),
      isSameYear: dateTo instanceof Date ? dateFrom.getFullYear() === dateTo.getFullYear() : false,
      isSameMonth: dateTo instanceof Date ? dateFrom.getMonth() === dateTo.getMonth() : false,
      first: dateFrom,
      last: dateTo
    };
  }

}
